export default {
  variant: 'cards.paper-lg',
  borderRadius: '0 0 15px 15px',
  borderWidth: '2px',
  borderColor: 'primary400',
};
